import { render } from "./submitTakeDialog.vue?vue&type=template&id=4b20fee6&scoped=true"
import script from "./submitTakeDialog.vue?vue&type=script&lang=js"
export * from "./submitTakeDialog.vue?vue&type=script&lang=js"

import "./submitTakeDialog.vue?vue&type=style&index=0&id=4b20fee6&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b20fee6"]])

export default __exports__